export default __webpack_public_path__ + "static/media/icon_support_cause.d1575b76.svg";